import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { HERO_IMAGES } from "../data/config";
import { HeroContactModal } from "../components/Contact/HeroContactModal";

export function HeroSection({ t, lang, handleNav }) {
  const [heroIdx, setHeroIdx] = useState(0);

  // Preload all hero images (fixes blank flash on first cycle)
  useEffect(() => {
    HERO_IMAGES.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    const id = setInterval(() => setHeroIdx((i) => (i + 1) % HERO_IMAGES.length), 4500);
    return () => clearInterval(id);
  }, []);

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Preloaded background images — opacity crossfade, no blank flash */}
      {HERO_IMAGES.map((src, i) => (
        <div
          key={src}
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${src})`,
            opacity: i === heroIdx ? 1 : 0,
            transition: "opacity 1s ease-in-out",
          }}
        />
      ))}
      <div className="absolute inset-0 bg-blue-900/50" />
      <div className="relative z-10 container mx-auto px-4 text-center pt-20">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black text-white mb-3 leading-tight">{t.hero.title}</h1>
          <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black text-white mb-2 leading-tight">{t.hero.subtitle}</h2>
          <h3 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black text-orange-300 mb-4 leading-tight">{t.hero.subtitle2}</h3>
          <p className="text-base md:text-xl text-white/90 mb-8 max-w-2xl mx-auto px-2">{t.hero.description}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 px-4">
            <button
              onClick={() => handleNav("courses")}
              className="w-full sm:w-auto inline-flex items-center justify-center bg-[#F08232] text-white px-8 py-4 rounded-full font-semibold text-base md:text-lg hover:bg-orange-400 transition-all duration-300 hover:scale-105 shadow-lg"
            >
              {t.hero.cta}
              <svg viewBox="0 0 24 24" className="ml-2 w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </button>
            <HeroContactModal lang={lang} />
          </div>
          <div className="flex items-center justify-center gap-2 mt-8">
            {HERO_IMAGES.map((_, i) => (
              <button
                key={i}
                onClick={() => setHeroIdx(i)}
                className={`h-2 rounded-full transition-all duration-300 ${i === heroIdx ? "bg-white w-6" : "bg-white/40 w-2"}`}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
          <div
            className="flex justify-center mt-4 animate-bounce cursor-pointer"
            onClick={() => document.getElementById("courses")?.scrollIntoView({ behavior: "smooth" })}
          >
            <svg viewBox="0 0 24 24" className="w-8 h-8 text-white/60 hover:text-white transition-colors" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9l6 6 6-6"/></svg>
          </div>
        </div>
      </div>
    </section>
  );
}
